import { formatFlightDay } from '@/lib/disruptions/airport-tz';
import type { CaseOverviewSummary } from './use-case-overview';

// Friendly-label derivation for the case header (frontend-conventions §18.3).
// Kept out of the component file so Fast Refresh stays component-only.
//
// Issue #605: The date must be the DEPARTURE date (`departureAt`) formatted in
// the DEPARTURE AIRPORT's timezone (`origin`), not the case creation time in
// the browser's timezone. This ensures the cases list and case detail header
// show the same date for the same flight.

/** `urn:flight:LA800:2026-05-26` / `urn:flight:latam:la2407-20260526` → `LA800`. */
export function flightNumberFromUrn(flightUrn: string | null | undefined): string | undefined {
  if (!flightUrn) return undefined;
  const m = /\b([A-Z]{2}\d{1,4})\b/.exec(flightUrn.toUpperCase());
  return m ? m[1] : undefined;
}

/** Compose the human label parts, dropping any we don't have. */
export function caseLabelParts(data: CaseOverviewSummary | undefined): string[] {
  if (!data) return [];
  const parts: string[] = [];
  const flight = flightNumberFromUrn(data.flightUrn);
  if (flight) parts.push(flight);
  if (data.airportCode && data.airportCode !== 'TBD') parts.push(data.airportCode);
  // Issue #605: Use departureAt (not openedAt) formatted in the origin airport's
  // timezone via formatFlightDay. This matches case-row.tsx for consistency.
  const date = formatFlightDay(data.departureAt, data.origin);
  if (date && date !== '—') parts.push(date);
  if (typeof data.passengerCount === 'number') parts.push(`${data.passengerCount} pax`);
  return parts;
}
